import { selectDisplaySettings, useMapStore } from "stores/map";

export function useUpdateRigFracIconSize() {
  const displaySettings = useMapStore(selectDisplaySettings);
  const setDisplaySettings = useMapStore((s) => s.setDisplaySettings);

  const updateRigIconSize = (newSize: number) => {
    setDisplaySettings({ ...displaySettings, rigIconSize: newSize });
  };

  const updateFracIconSize = (newSize: number) => {
    setDisplaySettings({ ...displaySettings, fracIconSize: newSize });
  };

  return { updateRigIconSize, updateFracIconSize };
}
